import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  "data-cy": "pizza-toppings",
  class: "pizza-toppings"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 5,
  "data-cy": "half-signature-section"
}
const _hoisted_6 = {
  key: 6,
  class: "more-toppings-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_radiolist = _resolveComponent("radiolist")!
  const _component_defaultToppings = _resolveComponent("defaultToppings")!
  const _component_proteinVeggieSelection = _resolveComponent("proteinVeggieSelection")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_toppingModal = _resolveComponent("toppingModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isHandTossed || _ctx.isStuffedCrust || _ctx.isBakery)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["mb-16", { 'd-none': _ctx.sauceCups?.length < 2 }])
        }, [
          _createVNode(_component_ion_card_title, { class: "mx-8 mb-8 ion-text-center bold" }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("Sauce Cup?")
            ])),
            _: 1
          }),
          _createVNode(_component_radiolist, {
            options: _ctx.sauceCups,
            keyName: "name",
            dense: "",
            modelValue: _ctx.localDressing,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDressing) = $event)),
            "data-cy": "choose-sauce-cup",
            defaultFirst: ""
          }, null, 8, ["options", "modelValue"])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.initialItem.isPizza)
      ? (_openBlock(), _createBlock(_component_ion_card_title, {
          key: 1,
          class: "mx-8 mb-8 ion-text-center bold"
        }, {
          default: _withCtx(() => [
            (_ctx.selectedRecipe?.isCyo && !_ctx.selectedRecipe?.isHandTossed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Load Up Your Pizza With Toppings Piled High!"))
              : (_ctx.selectedRecipe?.isHandTossed)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " This Pizza Comes Loaded With: "))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _cache[15] || (_cache[15] = [
                    _createTextVNode(" Load Up Your Pizza With Edge to Edge"),
                    _createElementVNode("sup", null, "®", -1),
                    _createTextVNode(" Toppings ")
                  ])))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.initialItem.isCalzato || _ctx.initialItem.isSub)
      ? (_openBlock(), _createBlock(_component_ion_card_title, {
          key: 2,
          class: "mx-8 mb-8 ion-text-center bold"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Customize Your " + _toDisplayString(_ctx.initialItem.isCalzato ? 'Calzato' : 'Sub'), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.initialItem.isCustomPizza)
      ? (_openBlock(), _createBlock(_component_defaultToppings, {
          key: 3,
          availableTopping: _ctx.availableTopping,
          defaultToppings: _ctx.localDefaultToppings,
          "onUpdate:defaultToppings": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localDefaultToppings) = $event)),
          hideSplitOpts: _ctx.initialItem.isSub || _ctx.initialItem.isCalzato || (!_ctx.initialItem.isCustomPizza && _ctx.initialItem.isClassic && !!_ctx.localToppings),
          toppingCount: _ctx.toppingCount
        }, null, 8, ["availableTopping", "defaultToppings", "hideSplitOpts", "toppingCount"]))
      : _createCommentVNode("", true),
    ((_ctx.initialItem.isCustomPizza || _ctx.initialItem.isBakery) && !_ctx.isHalfSig && _ctx.localToppings)
      ? (_openBlock(), _createBlock(_component_proteinVeggieSelection, {
          key: 4,
          availableTopping: _ctx.availableTopping,
          toppings: _ctx.wholeToppings,
          "onUpdate:toppings": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.wholeToppings) = $event)),
          hideSplitOpts: _ctx.initialItem.isSub || _ctx.initialItem.isCalzato || _ctx.initialItem.isBakery
        }, null, 8, ["availableTopping", "toppings", "hideSplitOpts"]))
      : (_ctx.initialItem.isPizza && _ctx.initialItem.isCustomPizza && _ctx.isHalfSig)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_ion_segment, {
              mode: "md",
              value: _ctx.currentSide,
              onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sideToggle($event.target.value)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, {
                  value: _ctx.PizzaSideEnum.left,
                  "data-cy": "button-select-left"
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode(" Left Side ")
                  ])),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_ion_segment_button, {
                  value: _ctx.PizzaSideEnum.right,
                  "data-cy": "button-select-right"
                }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode(" Right Side ")
                  ])),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["value"]),
            (_ctx.currentSide == _ctx.PizzaSideEnum.left)
              ? (_openBlock(), _createBlock(_component_radiolist, {
                  key: 0,
                  options: _ctx.signaturePizzas,
                  keyName: "name",
                  selectedKey: "nameAndDescription",
                  dense: "",
                  modelValue: _ctx.leftSideSig,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.leftSideSig) = $event)),
                  left: "",
                  onUpdate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal(_ctx.PizzaSideEnum.left, $event))),
                  "data-cy": "left-signature-list"
                }, null, 8, ["options", "modelValue"]))
              : (_openBlock(), _createBlock(_component_radiolist, {
                  key: 1,
                  options: _ctx.signaturePizzas,
                  keyName: "name",
                  selectedKey: "nameAndDescription",
                  dense: "",
                  modelValue: _ctx.rightSideSig,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rightSideSig) = $event)),
                  right: "",
                  onUpdate: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openModal(_ctx.PizzaSideEnum.right, $event))),
                  "data-cy": "right-signature-list"
                }, null, 8, ["options", "modelValue"]))
          ]))
        : (!_ctx.initialItem.isCustomPizza && !_ctx.initialItem.isClassic && _ctx.localToppings)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_toppingModal, {
                btnName: "More Toppings",
                showToppingPreview: "",
                onUpdate: _cache[8] || (_cache[8] = ($event: any) => (_ctx.wholeToppings = $event)),
                hideSplitOpts: _ctx.initialItem.isSub || _ctx.initialItem.isCalzato,
                availableTopping: _ctx.availableTopping,
                toppings: _ctx.wholeToppings,
                "onUpdate:toppings": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.wholeToppings) = $event)),
                parentToppingCount: _ctx.parentToppingCount,
                initialItem: _ctx.initialItem
              }, null, 8, ["hideSplitOpts", "availableTopping", "toppings", "parentToppingCount", "initialItem"])
            ]))
          : _createCommentVNode("", true),
    (_ctx.customSideModal && _ctx.currentSide == _ctx.PizzaSideEnum.left)
      ? (_openBlock(), _createBlock(_component_toppingModal, {
          key: 7,
          onClose: _ctx.customSideModalDelayClose,
          onUpdate: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateHalfModalTops(_ctx.PizzaSideEnum.left, $event))),
          justModal: "",
          hideSplitOpts: "",
          availableTopping: _ctx.availableTopping,
          parentToppingCount: 0,
          toppings: _ctx.leftToppings,
          "onUpdate:toppings": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.leftToppings) = $event))
        }, null, 8, ["onClose", "availableTopping", "toppings"]))
      : _createCommentVNode("", true),
    (_ctx.customSideModal && _ctx.currentSide == _ctx.PizzaSideEnum.right)
      ? (_openBlock(), _createBlock(_component_toppingModal, {
          key: 8,
          onClose: _ctx.customSideModalDelayClose,
          onUpdate: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateHalfModalTops(_ctx.PizzaSideEnum.right, $event))),
          justModal: "",
          hideSplitOpts: "",
          availableTopping: _ctx.availableTopping,
          parentToppingCount: 0,
          toppings: _ctx.rightToppings,
          "onUpdate:toppings": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.rightToppings) = $event))
        }, null, 8, ["onClose", "availableTopping", "toppings"]))
      : _createCommentVNode("", true)
  ]))
}